module.exports = __webpack_public_path__ + "static/scale-model-of-beneath-the-streets-in-seattle-washington-02ef2350547db97313256548f64f9c65.png";